import StorePoint from "../../components/credits/storePoints";
/**
 * StorePointsPages
 *
 * صفحه نمایش امتیازهای فروشگاه.
 *
 * @component
 * @returns JSX.Element
 */

const StorePointsPages = () => {
  return <StorePoint />;
};

export default StorePointsPages;
